import React from 'react'

export default function StarIcon(props) {

    return (
        <>
            <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M6 9.39183L2.94063 10.933C2.50026 11.1548 1.98725 10.7937 2.0718 10.3213L2.65513 7.06242L0.183331 4.75373C-0.17484 4.41919 0.0215317 3.83354 0.51491 3.76485L3.93431 3.28875L5.46276 0.321248C5.68337 -0.107083 6.31663 -0.107083 6.53724 0.321248L8.06569 3.28875L11.4851 3.76485C11.9785 3.83354 12.1748 4.41919 11.8167 4.75373L9.34487 7.06242L9.9282 10.3213C10.0127 10.7937 9.49974 11.1548 9.05937 10.933L6 9.39183Z" fill="#FFD166" />
            </svg>
        </>
    )
}